module.exports = __webpack_public_path__ + "img/leader_pl.d5250402.svg";